<script lang="ts">
  import Modal from "$components/+blocks/Modal/Modal.svelte";
  import { createEventDispatcher } from "svelte";
  import cx from "classnames";

  export let alt: string;
  export let src: string | null | undefined;
  export let cropPosition: "smart" | null = "smart";
  export let quality: "better" | "best" | "normal" | null = "better";
  export let allowZoom: boolean = false;
  export let disableSrcset: boolean = false;
  export let sizes: string = "(max-width: 600px) 100vw, (max-width: 1200px) 65vw, 50vw";
  export let objectFit: `object-${string}` = "object-cover";
  /** fallback to no srcset (non-uploadcare links) */
  export let fallback = false;

  let className: string = "size-full";
  export { className as class };

  let lightBoxOpen = false;
  const dispatch = createEventDispatcher();

  // generate uploadcard srcset manually for SSR
  $: srcset = [200, 400, 500, 800, 1000, 1300, 1600]
    .map(
      (width) =>
        `${src}-/resize/${width}x/-/format/auto/-/quality/${quality}/${
          cropPosition ? `-/scale_crop/${width}x${width}/smart` : ""
        } ${width}w`
    )
    .join(",");
</script>

<svelte:element
  this={allowZoom ? "button" : "div"}
  class="contents"
  on:click={() => (lightBoxOpen = true)}
  type={allowZoom ? "button" : null}
  role={allowZoom ? "button" : ""}
  aria-label={allowZoom ? "view larger image" : ""}
>
  <img
    {alt}
    {src}
    class:hover:scale-105={allowZoom}
    class:transition-transform={allowZoom}
    class={cx(quality, objectFit, className)}
    on:error={() => dispatch("error")}
    srcset={disableSrcset || fallback ? undefined : srcset}
    sizes={disableSrcset || fallback ? undefined : sizes}
  />
</svelte:element>

{#if allowZoom && lightBoxOpen}
  <!-- lightbox - opens images in a modal to view as a larger image -->
  <Modal
    maxWidth="max-w-fit"
    radius="rounded"
    backdropVariant="secondary"
    bind:open={lightBoxOpen}
    withCloseIcon
    closeIconVariant="theme-agnostic"
    disallowClickOutside={false}
  >
    <button
      class="contents"
      on:click={() => (lightBoxOpen = false)}
      type="button"
      aria-label="hide larger image"
    >
      <img
        {alt}
        {src}
        class="best h-auto max-h-[80vh] max-w-[80vw] cursor-zoom-out object-fill"
        srcset={fallback ? undefined : srcset}
        sizes={fallback ? undefined : "100vw"}
      />
    </button>
  </Modal>
{/if}
